import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import UploadTest from './components/UploadTest';
import './App.css';

function App() {
  useEffect(() => {
    // Check if we're in staging environment
    const isStaging = window.location.hostname.includes('staging') || 
                     window.location.hostname.includes('s3-website') ||
                     process.env.REACT_APP_ENVIRONMENT === 'staging';
    
    if (isStaging) {
      // Inject staging CSS
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = '/staging-indicator.css';
      document.head.appendChild(link);
      
      // Add floating indicator
      const indicator = document.createElement('div');
      indicator.className = 'staging-float-indicator';
      indicator.innerHTML = '🚧 STAGING 🚧';
      document.body.appendChild(indicator);
      
      // Change page title
      document.title = '🚧 STAGING - ' + document.title;
      
      // Log warning to console
      console.warn('%c�� STAGING ENVIRONMENT 🚧', 'background: #ff6b6b; color: white; font-size: 20px; padding: 10px;');
      console.warn('You are in the STAGING environment. Do not use real/sensitive data!');
    }
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<UploadTest />} />
      </Routes>
    </div>
  );
}

export default App;
